import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/shared/components/LanguageSwitcher';
import { AuthLoginFlow } from './AuthLoginFlow';

export const AuthLoginPage = () => {
  const { t } = useTranslation('app');

  return (
    <main className="prose min-w-full flex h-screen overflow-hidden bg-surface">
      <div
        aria-hidden
        className="fixed inset-x-0 top-0 z-40 h-[env(safe-area-inset-top)] bg-white"
      />
      <div
        aria-label="E-Label Solutions"
        className="w-full min-h-screen h-screen bg-linear-to-r from-ink to-surface bg-[url('/brand/login-hero.jpg')] bg-center bg-cover grow"
      />

      <section className="relative flex flex-col items-center justify-around min-h-screen gap-2 p-8 shadow-lg z-10 grow bg-white">
        <div className="absolute top-[calc(1rem+env(safe-area-inset-top))] right-4">
          <LanguageSwitcher menuPlacement="down" />
        </div>

        <header className="flex flex-col items-center w-2/5">
          <img alt="E-Label Solutions" className="h-auto w-full" src="/brand/el-logo.png" />
        </header>

        <div className="w-full">
          <h1 className="text-center">{t('login.title')}</h1>
          <AuthLoginFlow />
        </div>
      </section>
    </main>
  );
};
